








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Office } from '@/plugins/podolib/services/doctor';

@Component
export default class PatientAcquisitionExportationFrameDoctor extends Vue {
  @Prop(Boolean) private hideEmail!: boolean;
  @Prop(Boolean) private hidePhone!: boolean;
  @Prop(Boolean) private selectedOffice!: string;

  professions: string[] = [
    'neurologist',
    'orthopaedic_surgeon',
    'osteopath',
    'physiotherapist',
    'podiatrist',
    'sports_coach',
  ];

  get user() {
    return this.$store.state.pdc.doctor.user;
  }

  get email() {
    return this.user?.email;
  }

  get doctor() {
    return this.$store.state.pdc.doctor.current;
  }

  get office(): Office {
    return this.$store.getters['pdc/doctor/getOfficeWithId'](this.selectedOffice);
  }
}
